import { Autocomplete, TextField } from '@mui/material';
import classNames from 'classnames';
import { format } from 'date-fns';
import { uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import ImageResize from 'quill-image-resize-module-react';
import React, { Component } from 'react';
import toast from 'react-hot-toast';
import { withTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import Slider from 'react-slick';
import { Input } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';

import arrowLeft from '../../assets/img/arrow-long-left.svg';
import arrowRight from '../../assets/img/arrow-long-right.svg';
import book from '../../assets/img/book.svg';
import video from '../../assets/img/camera-video.svg';
import link from '../../assets/img/link.svg';
import { getMaterials } from '../../Common/Database';
import { MyRef, myStorage } from '../../Common/Firebase';
import { convertImageToWebp } from '../../Common/MediaConverter';
import withNavigateHook from '../../Components/withNavigateHook';
import { throwErrorRollbar } from '../../index';
import { gradeMappings, languageMappings } from '../ChecklistEditor/utils';

import 'react-quill/dist/quill.snow.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../ChecklistEditor/style.scss';

import { checklistAPI } from '../../api/checklist-api';
import { materialsAPI } from '../../api/materials-api';

const Quill = ReactQuill.Quill;

const BlockEmbed = Quill.import('blots/block/embed');
const Inline = Quill.import('blots/inline');

class AudioBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('class', 'audio-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class ImageBlot extends BlockEmbed {
  static create(value) {
    let node = super.create();
    node.setAttribute('alt', value.alt);
    node.setAttribute('src', value.url);
    node.setAttribute('class', 'img-fluid');
    return node;
  }
  static value(node) {
    return {
      alt: node.getAttribute('alt'),
      url: node.getAttribute('src'),
    };
  }
}

class VideoBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('class', 'video-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class LinkBlot extends Inline {
  static create(link) {
    const node = super.create();
    node.setAttribute('href', link);
    node.setAttribute('class', 'link-item');
    node.setAttribute('target', '_blank');
    return node;
  }

  static formats(node) {
    return node.getAttribute('href');
  }

  static value(node) {
    return node.getAttribute('href');
  }
}

// class ImageFormat extends Quill.import('formats/image') {
//   static formats(domNode) {
//     return {
//       alt: domNode.getAttribute('alt'),
//       src: domNode.getAttribute('src'),
//       width: domNode.getAttribute('width'),
//     };
//   }
//   format(name, value) {
//     if (name === 'width') {
//       this.domNode.setAttribute('width', value);
//     } else {
//       super.format(name, value);
//     }
//   }
// }

const SamplePrevArrow = ({ onClick }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  const handleButtonClick = () => {
    onClick();
    scrollToTop();
  };

  return (
    <button
      className={classNames('slick-arrow-left', {
        // disabled: currentItemIndex === 0,
      })}
      onClick={handleButtonClick}
    >
      <img src={arrowLeft} alt="arrow left" />
    </button>
  );
};

const SampleNextArrow = ({ onClick }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  const handleButtonClick = () => {
    onClick();
    scrollToTop();
  };

  return (
    <button
      className={classNames('slick-arrow-right', {
        // disabled: currentItemIndex === 0,
      })}
      onClick={handleButtonClick}
    >
      <img src={arrowRight} alt="arrow right" />
    </button>
  );
};

class ChecklistEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentQuill: null,
      courceName: '',
      courceTheme: '',
      courcePurpose: '',
      conditions: '',
      currentDate: format(new Date(), 'dd.MM.yyyy'),
      selectedStartDate: new Date(),
      selectedEndDate: new Date(),
      content: '',
      context: '',
      loading: false,
      videoInputRef: React.createRef(),
      audioInputRef: React.createRef(),
      imageInputRef: React.createRef(),
      currentItemIndex: 0,
      subArrayCheckeds: [],
      arrayFilesEditor: [],
      isForNotebook: false,
      quillCheckboxes: [],
      progressFilePost: 0,
      arrayFiles: [],
      selectedDate: null,
      selectedStartDateChange: '',
      selectedEndDateChange: '',
      chapterNum: '1',
      id: uuidv4(),
      lang: '',
      titles: [''],
      mail: '',
      materials: [],
      quillItems: [
        {
          id: uuidv4(),
          title: '',
          star: false,
          content: '',
          imageInputRef: React.createRef(),
          audioInputRef: React.createRef(),
          videoInputRef: React.createRef(),
        },
      ],
      classStudent: '',
      subjectCheckils: '',
      chapter: [
        {
          chapterNum: 1,
          materials: [],
          quillItems: [
            {
              id: uuidv4(),
              title: '',
              star: false,
              content: '',
              imageInputRef: React.createRef(),
              audioInputRef: React.createRef(),
              videoInputRef: React.createRef(),
            },
          ],
        },
      ],
      popupMaterial: false,
      materialsList: [],
      selectedMaterial: '',
      itemMaterial: null,
      materialName: '',
      objMaterial: null,
      currentChapterIndex: null,
      popupChapterIndex: null,
      popupFreeMaterial: false,
      materialFreeName: '',
      urlMaterial: '',
      examNumber: '',
      locationState: location.state,
    };

    this.sliderRef = React.createRef();
    this.context = React.createRef();
    this.onTextEditorChange = this.onTextEditorChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onNameChange = this.onNameChange.bind(this);
    this.setContext = this.setContext.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleImage = this.handleImage.bind(this);
    this.handleVideo = this.handleVideo.bind(this);
    this.handleAudio = this.handleAudio.bind(this);
    this.removeUrlListener = this.removeUrlListener.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.addQuillItem = this.addQuillItem.bind(this);
    this.addMaterial = this.addMaterial.bind(this);
    this.handleVideoInsert = this.handleVideoInsert.bind(this);
    this.handleImageInsert = this.handleImageInsert.bind(this);
    this.handleAudioInsert = this.handleAudioInsert.bind(this);
    this.handleLinkInsert = this.handleLinkInsert.bind(this);
    this.handleTitleMaterials = this.handleTitleMaterials.bind(this);
    this.onCourceNameChange = this.onCourceNameChange.bind(this);
    this.onExamNumberChange = this.onExamNumberChange.bind(this);
    this.onPurposeChange = this.onPurposeChange.bind(this);
    this.onPrerequisitesChange = this.onPrerequisitesChange.bind(this);
    this.onChapterNumChange = this.onChapterNumChange.bind(this);
    this.onCheckNotebook = this.onCheckNotebook.bind(this);
    this.handleNextSlide = this.handleNextSlide.bind(this);
    this.addChapters = this.addChapters.bind(this);
    this.removeMaterial = this.removeMaterial.bind(this);
    this.removeQuillItem = this.removeQuillItem.bind(this);
    this.removeChapter = this.removeChapter.bind(this);
    this.openAddMaterialsPopup = this.openAddMaterialsPopup.bind(this);
    this.handlerAddMaterials = this.handlerAddMaterials.bind(this);
    this.sendMaterialOnList = this.sendMaterialOnList.bind(this);
    this.openAddFreeMaterialsPopup = this.openAddFreeMaterialsPopup.bind(this);
    this.addFreeMaterialToList = this.addFreeMaterialToList.bind(this);
    this.difficultTask = this.difficultTask.bind(this);
    this.edit = this.edit.bind(this);

    AudioBlot.blotName = 'audio';
    AudioBlot.tagName = 'audio';
    ImageBlot.blotName = 'img';
    ImageBlot.tagName = 'img';
    VideoBlot.blotName = 'video';
    VideoBlot.tagName = 'video';
    LinkBlot.blotName = 'link';
    LinkBlot.tagName = 'a';

    Quill.register(AudioBlot);
    Quill.register(ImageBlot);
    Quill.register(VideoBlot);
    Quill.register(LinkBlot);
    // Quill.register(ImageFormat, true);
    Quill.register('modules/video', false);
    Quill.register('modules/imageResize', ImageResize);
  }

  componentDidMount() {
    const { location } = this.props;
    this.setState({ mail: this.props.mail });

    const fetchData = async () => {
      try {
        const materialsList = await getMaterials();
        this.setState({ materialsList });
      } catch (error) {
        throwErrorRollbar(error);
        throw error;
      }
    };

    fetchData();

    const fetchDataCheklist = async () => {
      try {
        if (location.state) {
          const row = location.state;
          const checklist = await checklistAPI.getChecklistById(row.id);

          if (checklist) {
            const chapterArray = Object.values(checklist.chapter);
            this.setState({
              examNumber: checklist.examNumber,
              courceName: checklist.name,
              id: checklist.id,
              classStudent: checklist.grade,
              courceTheme: '',
              thum: '',
              type: 'Exam',
              url: '',
              courcePurpose: checklist.purpose,
              conditions: checklist.conditions,
              subjectCheckils: checklist.subject,
              lang: checklist.lang,
              chapter: chapterArray.map(item => ({
                chapterNum: item.chapterNum,
                materials: item.materials.map(material => ({
                  id: material.id,
                  title: material.title,
                  url: material.url,
                  studentMaterial: material.studentMaterial ? material.studentMaterial : '',
                })),
                quillItems: item.points.map(quillItem => ({
                  content: JSON.parse(quillItem.content),
                  star: quillItem.star,
                  notebookLink: quillItem.notebookLink,
                  videoInputRef: React.createRef(),
                  audioInputRef: React.createRef(),
                  imageInputRef: React.createRef(),
                  id: uuidv4(),
                })),
              })),
            });
          }
        }
      } catch (error) {
        throwErrorRollbar(error);
        throw error;
      }
    };

    fetchDataCheklist();
  }

  handlerAddMaterials = (value, studentMaterial) => {
    this.setState({ materialName: value, objMaterial: studentMaterial });
  };

  openAddMaterialsPopup = chapterIndex => {
    this.setState({ popupMaterial: true, popupChapterIndex: chapterIndex });
  };

  openAddFreeMaterialsPopup = chapterIndex => {
    this.setState({ popupFreeMaterial: true, popupChapterIndex: chapterIndex });
  };

  sendMaterialOnList = (value, objMaterial, popupChapterIndex = this.popupChapterIndex) => {
    const newMaterial = {
      id: this.state.chapter[popupChapterIndex].materials.length + 1,
      title: value,
      url: '',
      studentMaterial: objMaterial,
    };

    this.setState(prevState => {
      const updatedChapters = [...prevState.chapter];
      updatedChapters[popupChapterIndex].materials.push(newMaterial);
      return { chapter: updatedChapters };
    });

    this.setState({ popupMaterial: false });
    this.setState({ popupMaterial: false, materialName: '', objMaterial: {} });
  };

  addFreeMaterialToList = (materialFreeName, urlMaterial, popupChapterIndex = this.popupChapterIndex) => {
    const newMaterial = {
      id: this.state.chapter[popupChapterIndex].materials.length + 1,
      title: materialFreeName,
      url: urlMaterial,
      studentMaterial: null,
    };

    this.setState(prevState => {
      const updatedChapters = [...prevState.chapter];
      updatedChapters[popupChapterIndex].materials.push(newMaterial);
      return { chapter: updatedChapters };
    });

    this.setState({ popupFreeMaterial: false });
    this.setState({ materialFreeName: '' });
    this.setState({ urlMaterial: '' });
  };

  classStudentHandler = event => {
    this.setState({ classStudent: event.target.value });
  };

  subjectCheckilsHandler = event => {
    this.setState({ subjectCheckils: event.target.value });
  };

  langCheckilsHandler = event => {
    this.setState({ lang: event.target.value });
  };

  addMaterial(chapterIndex) {
    const newMaterial = {
      id: this.state.chapter[chapterIndex].materials.length + 1,
      title: '',
      studentMaterial: '',
    };

    this.setState(prevState => {
      const updatedChapters = [...prevState.chapter];
      updatedChapters[chapterIndex].materials.push(newMaterial);
      return { chapter: updatedChapters };
    });
  }

  removeMaterial(chapterIndex, materialIndex) {
    this.setState(prevState => {
      const updatedChapters = [...prevState.chapter];
      updatedChapters[chapterIndex].materials.splice(materialIndex, 1);
      return { chapter: updatedChapters };
    });
  }

  addQuillItem(chapterIndex) {
    if (this.state.chapter[chapterIndex]) {
      const newQuillItem = {
        id: uuidv4(),
        title: '',
        content: '',
        star: false,
        imageInputRef: React.createRef(),
        audioInputRef: React.createRef(),
        videoInputRef: React.createRef(),
      };

      this.setState(prevState => {
        const updatedChapters = [...prevState.chapter];
        updatedChapters[chapterIndex].quillItems.push(newQuillItem);
        return { chapter: updatedChapters, currentQuill: newQuillItem };
      });
    }
  }

  removeQuillItem(chapterIndex, quillItemIndex) {
    this.setState(prevState => {
      const updatedChapters = [...prevState.chapter];
      updatedChapters[chapterIndex].quillItems.splice(quillItemIndex, 1);
      return { chapter: updatedChapters };
    });
  }

  difficultTask(chapterIndex, quillItemIndex) {
    const { chapter } = this.state;
    const updatedChapter = [...chapter];
    const quillItem = updatedChapter[chapterIndex].quillItems[quillItemIndex];
    quillItem.star = !quillItem.star;
    this.setState({ chapter: updatedChapter });
  }

  addChapters() {
    const newChapter = {
      chapterNum: this.state.chapter.length + 1,

      materials: [],
      quillItems: [
        {
          id: uuidv4(),
          title: '',
          content: '',
          star: false,
          imageInputRef: React.createRef(),
          audioInputRef: React.createRef(),
          videoInputRef: React.createRef(),
        },
      ],
    };

    this.setState(prevState => ({
      chapter: [...prevState.chapter, newChapter],
    }));

    this.sliderRef.current.slickGoTo(this.state.chapter.length + 1);

    window.scrollTo({ top: 0 });
  }

  removeChapter(chapterIndex) {
    this.setState(prevState => {
      const updatedChapters = [...prevState.chapter];
      updatedChapters.splice(chapterIndex, 1);
      return { chapter: updatedChapters };
    });
  }

  deltaToJson = delta => {
    return JSON.stringify(delta);
  };

  onTextEditorChange = (delta, editor, chapterIndex, quillItemIndex) => {
    this.setState(prevState => {
      const updatedChapters = [...prevState.chapter];
      updatedChapters[chapterIndex].quillItems[quillItemIndex].content = delta;
      return { chapter: updatedChapters };
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.quillItems !== this.state.quillItems) {
      console.log('didUpdate', this.state.quillItems);
    }
  }

  handleInputChange = (index, event) => {
    let newTitles = { ...this.state.titles };
    newTitles[index] = event.target.value;
    this.setState({ titles: newTitles });
  };

  handleTitleMaterials(chapterIndex, materialIndex, event) {
    const updatedChapters = [...this.state.chapter];
    updatedChapters[chapterIndex].materials[materialIndex].title = event.target.value;
    this.setState({ chapter: updatedChapters });
  }

  onKeyDown = async event => {
    if (event.keyCode === 8) {
      if (this.state.arrayFiles.length > this.state.arrayFilesEditor.length) {
        for (let item of this.state.arrayFiles) {
          if (this.state.arrayFilesEditor.includes(item) == false) {
            const storageRef = MyRef(myStorage, item);
            const stringDelete = storageRef._location.path_;

            const desertRef = MyRef(myStorage, stringDelete);
            this.setState({
              arrayFiles: this.state.arrayFiles.filter(filterElem => filterElem !== item),
            });
            try {
              await deleteObject(desertRef)
                .then(() => {
                  console.log('deleted');
                })
                .catch(error => {
                  console.log(error);
                  throwErrorRollbar(error);
                });
            } catch (error) {
              console.log(error);
              throwErrorRollbar(error);
            }
          }
        }
      }
    }
  };

  onNameChange(event) {
    this.setState({ name: event.target.value });
  }

  removeUrlListener(delta, oldContents, source) {
    let currentContenst = this.state.contextObject.getEditor().getContents();

    let deletedDiffs = currentContenst.diff(oldContents);
    let deletedUrls = this.getUrls(deletedDiffs);

    deletedUrls.forEach(url => {
      this.state.deletedUrls.push(url);
      this.state.addedUrls.pop(url);
    });

    let addedUrls = this.getUrls(delta);

    addedUrls.forEach(url => {
      this.state.addedUrls.push(url);
    });
  }

  getUrls(diffs) {
    return diffs.ops
      .filter(diff => diff.insert && (diff.insert.image || diff.insert.video || diff.insert.audio))
      .map(diff => {
        if (diff.insert.image) return diff.insert.image;

        if (diff.insert.video) return diff.insert.video;

        return diff.insert.audio;
      });
  }

  setContext(context) {
    this.setState({ contextObject: context });
  }

  handleVideoInsert = (quillItem, chapterIndex) => {
    const videoInput = quillItem.videoInputRef.current;

    if (videoInput && videoInput.files.length > 0) {
      const file = videoInput.files[0];
      const formData = new FormData();
      formData.append('file', file);

      const quill = quillItem.quillInstance.getEditor();
      const range = quill.getSelection(true);

      const storageRef = MyRef(myStorage, 'Контрольные-листы/video/' + file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          this.setState({ progressFilePost: String(progress).split('.')[0] });

          switch (snapshot.state) {
            case 'paused':
              console.log('Загрузка приостановлена');
              break;
            case 'running':
              console.log('Идет загрузка');
              break;
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            this.setState({ progressFilePost: 0 });

            quill.insertEmbed(range.index, 'video', downloadURL, Quill.sources.USER);

            this.setState({
              arrayFiles: this.state.arrayFiles.concat([downloadURL]),
            });

            const slider = this.sliderRef.current;
            slider.slickGoTo(chapterIndex + 1);
          });
        },
      );
    }
  };

  handleImageInsert = async (quillItem, chapterIndex) => {
    const imageInput = quillItem.imageInputRef.current;

    if (imageInput && imageInput.files.length > 0) {
      const file = imageInput.files[0];
      const formData = new FormData();

      const webpFile = await convertImageToWebp(URL.createObjectURL(file), file);
      formData.append('file', webpFile);

      const quill = quillItem.quillInstance.getEditor();
      const range = quill.getSelection(true);

      const storageRef = MyRef(myStorage, 'Контрольные-листы/image/' + webpFile.name);
      const uploadTask = uploadBytesResumable(storageRef, webpFile);

      uploadTask.on(
        'state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          this.setState({ progressFilePost: String(progress).split('.')[0] });

          switch (snapshot.state) {
            case 'paused':
              console.log('Загрузка приостановлена');
              break;
            case 'running':
              console.log('Идет загрузка');
              break;
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            this.setState({ progressFilePost: 0 });
            const clipboard = quill.getModule('clipboard');
            const imageHtml = `<img src="${downloadURL}">`;
            clipboard.dangerouslyPasteHTML(range.index, imageHtml, 'user');

            this.setState({
              arrayFiles: this.state.arrayFiles.concat([downloadURL]),
            });

            const slider = this.sliderRef.current;
            slider.slickGoTo(chapterIndex + 1);
          });
        },
      );
    }
  };

  handleAudioInsert = (quillItem, chapterIndex) => {
    const audioInput = quillItem.audioInputRef.current;

    if (audioInput && audioInput.files.length > 0) {
      const file = audioInput.files[0];
      const formData = new FormData();
      formData.append('file', file);

      const quill = quillItem.quillInstance.getEditor();
      const range = quill.getSelection(true);

      const storageRef = MyRef(myStorage, 'Контрольные-листы/audio/' + file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          this.setState({ progressFilePost: String(progress).split('.')[0] });

          switch (snapshot.state) {
            case 'paused':
              console.log('Загрузка приостановлена');
              break;
            case 'running':
              console.log('Идет загрузка');
              break;
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            this.setState({ progressFilePost: 0 });

            quill.insertEmbed(range.index, 'audio', downloadURL, Quill.sources.USER);

            this.setState({
              arrayFiles: this.state.arrayFiles.concat([downloadURL]),
            });

            const slider = this.sliderRef.current;
            slider.slickGoTo(chapterIndex + 1);
          });
        },
      );
    }
  };

  handleLinkInsert = (quillItem, url) => {
    if (url) {
      console.log('quillItem: ', quillItem);
    }
  };

  handleCheckboxChange(index, e) {
    const newCheckboxes = [...this.state.quillCheckboxes];
    newCheckboxes[index] = e.target.checked;
    this.setState({ quillCheckboxes: newCheckboxes });
  }

  CustomToolbar = props => (
    <>
      <div className="homework-edit-toolbar checkist-edit-quill" id={`toolbar-${props.quillItem.id}`}>
        <button
          className="ql-link btn btn-secondary more btn-quill"
          onClick={url => {
            this.handleLinkInsert(props.quillItem, url);
            console.log('props: ', props);
          }}
        >
          <img src={link} alt="link" />
        </button>

        <div className="ql-audio button-icon toolbar-add-img toolbar-add-audio btn-quill btn btn-secondary more">
          <input
            id={`audioInput-${props.quillItem.id}`}
            type="file"
            accept="audio/aac,audio/mp3,audio/vbr,audio/audible,audio/aiff,audio/wav,audio/alac,audio/*"
            // style={{ display: 'none' }}
            ref={props.quillItem.audioInputRef}
            onChange={() => this.handleAudioInsert(props.quillItem, props.chapterIndex)}
          />
        </div>

        <div className="ql-image button-icon toolbar-add-img btn-quill btn btn-secondary more">
          <input
            id={`imageInput-${props.quillItem.id}`}
            type="file"
            accept="image/*"
            ref={props.quillItem.imageInputRef}
            onChange={() => this.handleImageInsert(props.quillItem, props.chapterIndex)}
          />
        </div>

        <input
          id={`videoInput-${props.quillItem.id}`}
          type="file"
          accept="video/mp4,video/x-m4v,video/*"
          style={{ display: 'none' }}
          ref={props.quillItem.videoInputRef}
          onChange={() => this.handleVideoInsert(props.quillItem, props.chapterIndex)}
        />

        <button
          className="ql-video btn btn-secondary more btn-quill"
          onClick={() => props.quillItem.videoInputRef.current.click()}
        >
          <img src={video} alt="video" />
        </button>
      </div>
    </>
  );

  handleImage() {
    this.handleFile('image/*', 'image');
  }

  handleVideo() {
    this.handleFile('video/*', 'video');
  }

  handleAudio() {
    this.handleFile('audio/*', 'audio');
  }

  onSubjectChange = e => {
    let subject = e.target.selectedIndex == 0 ? null : e.target.value;
    this.setState({
      subject,
    });
  };

  handleFile(extension, type) {
    const input = document.createElement('input');

    input.setAttribute('type', 'file');
    input.setAttribute('accept', extension);
    input.click();

    input.onchange = async () => {
      let file = input.files[0];
      let formData = new FormData();
      formData.append('file', file);

      const storageRef = MyRef(myStorage, 'Контрольные-листы/' + type + '/' + file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          this.setState({ progressFilePost: String(progress).split('.')[0] });

          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            this.setState({ progressFilePost: 0 });

            let quill = this.state.contextObject.getEditor();
            let range = quill.getSelection(true);

            quill.insertEmbed(range.index, 'video', downloadURL, Quill.sources.USER);

            this.setState({
              arrayFiles: this.state.arrayFiles.concat([downloadURL]),
            });
          });
        },
      );
    };
  }

  onCourceNameChange(event) {
    this.setState({ courceName: event.target.value });
  }

  onExamNumberChange(event) {
    this.setState({ examNumber: event.target.value });
  }

  onPurposeChange(event) {
    this.setState({ courcePurpose: event.target.value });
  }

  onChapterNumChange(event) {
    this.setState({ chapterNum: event.target.value });
  }

  onPrerequisitesChange(event) {
    this.setState({ conditions: event.target.value });
  }

  onCheckNotebook(event) {
    this.setState({ isForNotebook: event.target.value });
  }

  handleNotebookCheckboxChange = (chapterIndex, quillItemIndex, isChecked) => {
    const updatedChapters = [...this.state.chapter];
    updatedChapters[chapterIndex].quillItems[quillItemIndex].isForNotebook = isChecked;
    this.setState({ chapter: updatedChapters });
  };

  handleNextSlide = () => {
    const newChapterItem = {
      id: uuidv4(),
      title: '',
      content: '',
    };
    const updatedChapter = [...this.state.chapter, newChapterItem];
    this.setState({ chapter: updatedChapter });
  };

  async edit() {
    const currentDate = format(new Date(), 'dd.MM.yyyy');

    const chaptersObj = {};
    this.state.chapter.forEach(chapter => {
      chaptersObj[chapter.chapterNum] = {
        chapterNum: chapter.chapterNum,
        materials: chapter.materials,
        points: chapter.quillItems.map(item => ({
          content: this.deltaToJson(item.content),
          star: item.star,
          notebookLink: item.isForNotebook === undefined ? false : item.isForNotebook,
        })),
      };
    });

    const { location } = this.props;
    const languageUkrainian = languageMappings[this.state.subjectCheckils] || this.state.subjectCheckils;
    const classStudentUkrainian = gradeMappings[this.state.classStudent] || this.state.classStudent;

    const id = location.state.id;
    const newData = {
      id,
      examNumber: this.state.examNumber,
      purpose: this.state.courcePurpose,
      expirationData: new Date(),
      startDate: new Date(),
      grade: classStudentUkrainian,
      subject: languageUkrainian,
      mail: this.state.mail,
      lang: this.state.lang,
      name: this.state.courceName,
      theme: '',
      conditions: this.state.conditions,
      thum: '',
      url: '',
      type: 'Exam',
      chapter: chaptersObj,
      courseCompletion: {
        courseExaminer: currentDate,
      },
    };

    try {
      await materialsAPI.updateMaterial(id, newData);
    } catch (error) {
      console.error('Error adding object to document:', error);
      error.name = 'Error adding object to document:';
      throwErrorRollbar(error);
    }

    toast.success(this.props.t('popupMaterialUpdated'));
    this.props.navigation('/materials');
  }

  render() {
    const settings = {
      dots: false,
      infinite: false,
      adaptiveHeight: true,
      swipe: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: '50px',
      accessibility: false,
      prevArrow: <SamplePrevArrow />,
      nextArrow: <SampleNextArrow onClick={() => this.addChapters()} />,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            swipe: true,
          },
        },
      ],
    };

    return (
      <>
        <div className="wrap-slider">
          <Slider ref={this.sliderRef} {...settings} className="slider-container checklist-editor-slider">
            <div className="materials-page checklist-page first-slide container">
              <div className="title-wrap">
                <div className="wrap-name-exem">
                  <h1>
                    {this.props.t('checklist')} №
                    <label htmlFor="" className="exam-number">
                      <input
                        type="text"
                        onChange={this.onExamNumberChange}
                        value={this.state.examNumber}
                        placeholder="0"
                      />
                    </label>
                  </h1>
                </div>

                <label htmlFor="" className="cource-name">
                  {this.props.t('Cource name')}:{' '}
                  <input
                    type="text"
                    onChange={this.onCourceNameChange}
                    value={this.state.courceName}
                    placeholder={this.props.t('Enter Title')}
                  />
                </label>
              </div>
              <div className="checlist-content">
                <p>
                  {this.props.t(
                    'This is a control sheet. It contains tasks that you need to complete in turn. Put the date and your signature when you completed the task on the dash next to the task.',
                  )}
                </p>
                <p>
                  {this.props.t(
                    'Whenever you come across a word that you do not understand or the meaning of which you are not sure, consult a dictionary.',
                  )}
                </p>
                <p>{this.props.t('If you have any questions, please contact your supervisor.')}</p>
                <p>
                  {this.props.t(
                    'A supervisor is the head of the course and is there to help you get the most out of the course.',
                  )}
                </p>
                <div className="purpose-wrap">
                  <label htmlFor="">
                    {this.props.t('Purpose of the course')}:{' '}
                    <input
                      type="text"
                      onChange={this.onPurposeChange}
                      value={this.state.courcePurpose}
                      placeholder={this.props.t('Enter the text')}
                    />
                  </label>
                  <label htmlFor="">
                    {this.props.t('Prerequisites')}:{' '}
                    <input
                      type="text"
                      onChange={this.onPrerequisitesChange}
                      value={this.state.conditions}
                      placeholder={this.props.t('Enter the text')}
                    />
                  </label>
                  <label htmlFor="" className="select-class">
                    {this.props.t('class')}:{' '}
                    <Autocomplete
                      id="classStudent"
                      autoComplete={false}
                      options={[
                        this.props.t('1 клас'),
                        this.props.t('2 клас'),
                        this.props.t('3 клас'),
                        this.props.t('4 клас'),
                        this.props.t('6 клас'),
                        this.props.t('5 клас'),
                        this.props.t('7 клас'),
                        this.props.t('8 клас'),
                        this.props.t('9 клас'),
                        this.props.t('10 клас'),
                        this.props.t('11 клас'),
                        this.props.t('ЗНО'),
                        this.props.t('ЗНО поглиблений рівень'),
                        this.props.t('Express course - Beginner'),
                        this.props.t('Express course - Elementary'),
                        this.props.t('Express course - Intermediate'),
                        this.props.t('Express course - Pre-Intermediate'),
                        this.props.t('Kids - Additional'),
                        this.props.t('Kids - Advanced'),
                        this.props.t('Kids - Beginner'),
                        this.props.t('Kids - Elementary'),
                        this.props.t('Kids - Intermidiate'),
                        this.props.t('Kids - Pre-Intermidiate'),
                      ]}
                      value={this.state.classStudent}
                      onInputChange={(e, v) => this.setState({ classStudent: v })}
                      renderInput={params => (
                        <TextField
                          {...params}
                          value={this.state.classStudent}
                          onChange={this.classStudentHandler}
                          placeholder={this.props.t('Choose a class')}
                        />
                      )}
                    />
                  </label>
                  <label htmlFor="" className="select-class">
                    {this.props.t('subject')}:{' '}
                    <Autocomplete
                      id="subjectCheckils"
                      options={[
                        this.props.t('algebra'),
                        this.props.t('english'),
                        this.props.t('biology'),
                        this.props.t('allWorldHistory'),
                        this.props.t('geography'),
                        this.props.t('geometry'),
                        this.props.t('foreignLiterature'),
                        this.props.t('historyUkraine'),
                        // this.props.t('infografics'),
                        this.props.t('kvol'),
                        this.props.t('mathematics'),
                        this.props.t('youngSchoolMathematics'),
                        this.props.t('youngSchoolRussianLanguage'),
                        this.props.t('youngUkrainianLanguage'),
                        this.props.t('german'),
                        this.props.t('nature'),
                        this.props.t('ukrainianLiterature'),
                        this.props.t('ukrainianLanguage'),
                        this.props.t('physics'),
                        this.props.t('chemistry'),
                      ]}
                      value={this.state.subjectCheckils}
                      onInputChange={(e, v) => this.setState({ subjectCheckils: v })}
                      renderInput={params => (
                        <TextField
                          {...params}
                          value={this.state.subjectCheckils}
                          onChange={this.subjectCheckilsHandler}
                          placeholder={this.props.t('Choose a subject')}
                        />
                      )}
                    />
                  </label>
                  <label htmlFor="" className="select-class">
                    {this.props.t('language')}:{' '}
                    <Autocomplete
                      id="lang"
                      options={['UA', 'EN', 'DE', 'RU']}
                      value={this.state.lang}
                      onInputChange={(e, v) => this.setState({ lang: v })}
                      renderInput={params => (
                        <TextField
                          {...params}
                          value={this.state.lang}
                          onChange={this.langCheckilsHandler}
                          placeholder={this.props.t('Choose a language')}
                        />
                      )}
                    />
                  </label>
                </div>
              </div>
            </div>

            {this.state.chapter.map((chapter, chapterIndex) => (
              <>
                <div key={chapterIndex} className="materials-page checklist-page sec-slide container">
                  <button
                    className="btn btn-icon delete-checklist-btn delete-chapter"
                    onClick={() => this.removeChapter(chapterIndex)}
                  >
                    <span className="icon icon-plus"></span>
                  </button>
                  <label htmlFor="" className="cource-name chapter">
                    {this.props.t('Chapter')} №:{' '}
                    <input
                      type="text"
                      placeholder="0"
                      readOnly
                      onChange={this.onChapterNumChange}
                      value={chapter.chapterNum}
                    />
                  </label>
                  <div className="new-materials-container">
                    <div className="materials-wrap">
                      <div className="content-wrap">
                        <div className="title">
                          <h3>{this.props.t('materials')}:</h3>
                        </div>
                        <div className="content">
                          {chapter.materials.length ? (
                            <>
                              {chapter.materials.map((material, materialIndex) => (
                                <label key={material.id} htmlFor="" className="cource-name materials">
                                  <span className="material-numb">{materialIndex + 1}.</span>
                                  <img src={book} alt="book" />
                                  <input
                                    type="text"
                                    placeholder={this.props.t('Enter Title')}
                                    value={material.title}
                                    readOnly
                                    onChange={event => this.handleTitleMaterials(chapterIndex, materialIndex, event)}
                                  />
                                  <button
                                    className="btn btn-icon delete-checklist-btn delete-comment"
                                    onClick={() => this.removeMaterial(chapterIndex, materialIndex)}
                                  >
                                    <span className="icon icon-plus"></span>
                                  </button>
                                </label>
                              ))}
                            </>
                          ) : (
                            <p>{this.props.t('Use the buttons to add one or more materials')}</p>
                          )}
                        </div>
                      </div>

                      <div className="btn-wrap">
                        <button
                          className="btn btn-secondary btn-view with-icon"
                          onClick={() => this.openAddFreeMaterialsPopup(chapterIndex)}
                        >
                          <span className="icon icon-plus"></span>
                          {this.props.t('add link')}
                        </button>

                        <button
                          className="btn btn-secondary btn-view with-icon"
                          onClick={() => this.openAddMaterialsPopup(chapterIndex)}
                        >
                          <span className="icon icon-plus"></span>
                          {this.props.t('add mat')}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="quill-container">
                    {chapter.quillItems.map((quillItem, quillItemIndex) => {
                      if (quillItem.isForNotebook === undefined) {
                        quillItem.isForNotebook = quillItem.notebookLink;
                      }

                      return (
                        <div
                          className={classNames('quill-item', {
                            color: this.state.chapter[chapterIndex].quillItems[quillItemIndex].star,
                          })}
                          data-point-number={`${chapterIndex + 1}.${quillItemIndex + 1}.`}
                          key={quillItem.id}
                        >
                          <button
                            className="btn btn-icon delete-checklist-btn delete-quill"
                            onClick={() => this.removeQuillItem(chapterIndex, quillItemIndex)}
                          >
                            <span className="icon icon-plus"></span>
                          </button>
                          <button
                            className="btn btn-icon star"
                            onClick={() => this.difficultTask(chapterIndex, quillItemIndex)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                            >
                              <path
                                d="M16 23.462l9.593 6.396-4.264-10.659 9.593-6.396h-10.659l-4.264-10.659-4.264 10.659h-10.659l9.593 6.396-4.264 10.659 9.593-6.396z"
                                fill="#000"
                              />
                              <g className="star-bg">
                                <path
                                  d="M16 22.132l-7.248 4.847 3.411-8.208-7.675-4.903h7.994l3.518-9.060 3.518 9.060h7.994l-7.675 4.903 3.411 8.208-7.248-4.847z"
                                  fill="#fff"
                                />
                              </g>
                            </svg>
                            {this.props.t('Assignment with star')}
                          </button>
                          <ReactQuill
                            onFocus={() => this.setState({ currentQuill: quillItem })}
                            modules={{
                              toolbar: {
                                container: `#toolbar-${quillItem.id}`,
                                handlers: {
                                  audio: this.handleClick,
                                  image: this.handleClick,
                                  video: this.handleClick,
                                },
                              },
                              imageResize: {
                                parchment: Quill.import('parchment'),
                                modules: ['Resize', 'DisplaySize'],
                                bounds: '.ql-editor',
                              },
                              clipboard: {
                                matchVisual: false,
                              },
                            }}
                            ref={ref => (quillItem.quillInstance = ref)}
                            value={quillItem.content}
                            onChange={(content, delta, source, editor) =>
                              this.onTextEditorChange(editor.getContents(), editor, chapterIndex, quillItemIndex)
                            }
                            onKeyDown={this.onKeyDown}
                            theme="snow"
                          />

                          <div className="custom-toolbar">
                            <this.CustomToolbar quillItem={quillItem} chapterIndex={chapterIndex} />
                          </div>

                          <div className="check-notebook">
                            <label htmlFor={`checkNotebook-${quillItemIndex}`}>
                              {this.props.t('Do in your notebook')}{' '}
                            </label>
                            <Input
                              id={`checkNotebook-${quillItemIndex}`}
                              type="checkbox"
                              className="form-check-input"
                              checked={quillItem.isForNotebook}
                              onChange={e => {
                                this.handleNotebookCheckboxChange(chapterIndex, quillItemIndex, e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}

                    <div className="btn-wrap">
                      <button
                        className="btn btn-primary more with-icon"
                        onClick={() => {
                          this.addQuillItem(chapterIndex);
                        }}
                      >
                        <span className="icon icon-plus"></span>
                        {this.props.t('add task')}
                      </button>
                      <button className="btn btn-primary more with-icon" onClick={this.addChapters}>
                        <span className="icon icon-plus"></span> {this.props.t('create a new section')}
                      </button>
                      <button
                        className={classNames('btn btn-primary more', {
                          disabled:
                            this.state.courcePurpose === '' ||
                            this.state.id === '' ||
                            this.state.classStudent === '' ||
                            this.state.subjectCheckils === '' ||
                            this.state.mail === '' ||
                            this.state.lang === '' ||
                            this.state.courceName === '' ||
                            this.state.examNumber === '' ||
                            this.state.chapterNum === '' ||
                            this.state.conditions === '',
                        })}
                        onClick={this.edit}
                      >
                        {this.props.t('edit and exit')}
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ))}
          </Slider>

          <div
            className={classNames('popup-send-homework', {
              active: this.state.popupMaterial,
            })}
          >
            {this.state.popupMaterial && (
              <div className="popup-send-homework-content">
                <div className="modal-header">
                  <h3>{this.props.t('add material')}</h3>
                  <button className="btn btn-icon" onClick={() => this.setState({ popupMaterial: false })}>
                    <span className="icon icon-plus"></span>
                  </button>
                </div>

                <div className="wrap-select-send">
                  <label htmlFor="" className="select-add-materials">
                    <Autocomplete
                      id="add-material"
                      autoComplete={false}
                      options={this.state.materialsList.map(material => ({
                        value: material.name,
                        label: material.name,
                        url: material,
                      }))}
                      value={this.state.materialName}
                      onChange={(e, newValue) => {
                        if (newValue) {
                          this.setState({
                            materialName: newValue.value,
                            objMaterial: newValue.url,
                          });
                        } else {
                          this.setState({ materialName: '', objMaterial: '' });
                        }
                      }}
                      onInputChange={(e, v, reason) => {
                        if (reason === 'input') {
                          this.handlerAddMaterials(v, this.state.objMaterial);
                        }
                      }}
                      renderInput={params => (
                        <TextField
                          {...params}
                          value={this.state.materialName}
                          onChange={e => this.handlerAddMaterials(e.target.value, this.state.objMaterial)}
                          placeholder={this.props.t('select a material from the list')}
                        />
                      )}
                    />
                  </label>
                </div>

                <div className="button-send-row">
                  <button
                    className={classNames('btn btn-primary more', {
                      disabled: this.state.materialName === '',
                    })}
                    onClick={() =>
                      this.sendMaterialOnList(
                        this.state.materialName,
                        this.state.objMaterial,
                        this.state.popupChapterIndex,
                      )
                    }
                  >
                    <span>{this.props.t('send')}</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          className={classNames('popup-send-homework popup-checklist-material', {
            active: this.state.popupFreeMaterial,
          })}
        >
          {this.state.popupFreeMaterial && (
            <div className="popup-send-homework-content">
              <div className="modal-header">
                <h3>{this.props.t('add material')}</h3>
                <button className="btn btn-icon" onClick={() => this.setState({ popupFreeMaterial: false })}>
                  <span className="icon icon-plus"></span>
                </button>
              </div>

              <TextField
                id="outlined-basic"
                label={this.props.t('name material')}
                variant="outlined"
                className="field"
                value={this.state.materialFreeName}
                onChange={e => this.setState({ materialFreeName: e.target.value })}
              />

              <TextField
                id="outlined-basic"
                label={this.props.t('Link to material')}
                variant="outlined"
                className="field"
                value={this.state.urlMaterial}
                onChange={e => this.setState({ urlMaterial: e.target.value })}
              />

              <div className="button-send-row">
                <button
                  className={classNames('btn btn-primary more', {
                    disabled: this.state.materialFreeName === '',
                  })}
                  onClick={() =>
                    this.addFreeMaterialToList(
                      this.state.materialFreeName,
                      this.state.urlMaterial,
                      this.state.popupChapterIndex,
                    )
                  }
                >
                  <span>{this.props.t('send')}</span>
                </button>
              </div>
            </div>
          )}
        </div>

        <div
          className={classNames('progress-loader-wrap', {
            active: this.state.progressFilePost > 0,
          })}
        >
          <div className="progress-loader-item">
            <div
              className="progress-loader-content"
              style={{
                width: this.state.progressFilePost + '%',
              }}
            >
              <span>{this.state.progressFilePost}%</span>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(withNavigateHook(ChecklistEdit));
